import TopLaptops from "../../assets/images/image-top-laptops.jpg";
import RetroPcs from "../../assets/images/image-retro-pcs.jpg";
import GamingWorth from "../../assets/images/image-gaming-growth.jpg";
import "./index.scss";

type TopTechList = {
  imageUrl: string;
  order: string;
  title: string;
  description: string;
};

const topTechList: TopTechList[] = [
  {
    imageUrl: RetroPcs,
    order: "01",
    title: "Reviving Retro PCs",
    description: "What happens when old PCs are given modern upgrades?",
  },
  {
    imageUrl: TopLaptops,
    order: "02",
    title: "Top 10 Laptops of 2022",
    description: "Our best picks for various needs and budgets.",
  },
  {
    imageUrl: GamingWorth,
    order: "03",
    title: "The Growth of Gaming",
    description: "How the pandemic has sparked fresh opportunitites.",
  },
];
export default function TopTech() {
  return (
    <div className="toptech">
      {topTechList.map(({ imageUrl, order, title, description }, index) => {
        return (
          <div key={index} className="toptech__wrapper">
            <div className="toptech__wrapper__image">
              <img src={imageUrl} alt={title} />
            </div>
            <span className="toptech__wrapper__order">{order}</span>
            <span className="toptech__wrapper__title">{title}</span>
            <p className="toptech__wrapper__description">{description}</p>
          </div>
        );
      })}
    </div>
  );
}
